import { Phone, Scopes } from './';
import { AccountOutput } from './account-output.model';

export interface Customer {
  /**
   * Unique relation id eg. "rid:cmp=1bbebaea-175a-49b0-b949-c7ea9d687206#prs=e7ae97c2-e109-4924-889e-7f39236f2acc"
   *
   */
  relId?: string;
  _id?: string;

  usrId?: string;

  /**
   * Company id eg. "cfbb2891-7915-4644-8ce8-43d242eb2e1c"
   *
   */
  relCmpId?: string;

  /**
   * Email address
   *
   */
  email?: string;

  /**
   * Invitation flag for new customers
   * always set true for out of CRM invitations
   *
   */
  snd?: boolean;

  /**
   * Role eg. 2000 (Personal account)
   *
   */
  rl?: number;

  /**
   * Status
   * 100 - not active user
   * 500 - active user
   *
   */
  sts?: number;

  /**
   * User's info
   *
   */
  prs?: Person;

  /**
   * Company info
   *
   */
  cmp?: AccountOutput;
  /**
   * Company info
   *
   */
  acn?: AccountOutput;
  _scopes?: Scopes;
  avatarId?: string;

  /**
   * true - immediately accepts invitation like it used to be. Use in Contacts
   * false - creates a pending contact invitation and sends email. Use in Lender Connect for out of CRM invitations
   */
  autoAcceptInvitation?: boolean;

  /**
   * current deal id, only use in Lender Connect
   */
  dealInvitedToId?: string;
  /**
   * Text field "personal message" contents
   */
  customEmailContent?: string;

  invitationStatus?: InvitationStatus;
  areaOfResponsibility?: string;
}

export const InvitationStatuses = {
  CONNECTED: 2,
  DECLINED: 3,
  INVITED: 1000,
};

export type InvitationStatus =
  (typeof InvitationStatuses)[keyof typeof InvitationStatuses];

export interface Staff {
  /**
   * Unique relation id eg. "email:support@qtnology.us"
   *
   */
  relId?: string;
  _id?: string;
  /**
   * Person id eg. "1232ba91-7c50-4bb1-a979-0700de41c0a4"
   *
   */
  prsId?: string;

  /**
   * Email address
   *
   */
  email?: string;

  /**
   * Status
   * 100 - not active user
   * 500 - active user
   *
   */
  sts?: number;

  /**
   * Role eg. 10 (admin)
   *
   */
  rl?: number;

  /**
   * User type
   * 0 - non-user / not active
   * 1 - ?
   * 50 - lead
   * 200 - active user
   *
   */
  usrFlg?: 0 | 1 | 50 | 200;

  /**
   *  User's details
   *
   */
  prs?: Person;
  /**
   * Company info
   *
   */
  acn?: AccountOutput;
  areaOfResponsibility?: string;
  _scopes?: any;
}

export interface Person {
  /**
   * Full name
   *
   */
  name?: string;

  /**
   * First name
   *
   */
  fname?: string;

  /**
   * Middle name
   *
   */
  mname?: string;

  /**
   * Last name
   *
   */
  lname?: string;

  /**
   * Language eg. "pl_PL"
   *
   */
  lng?: string;

  /**
   *  Person id eg. "e7ae97c2-e109-4924-889e-7f39236f2acc"
   *
   */
  prsId?: string;

  /**
   *  Timezone eg. "Europe/Warsaw"
   *
   */
  tz?: string;

  /**
   * Email address
   *
   */
  email?: string;

  /**
   * User's phones
   *
   */
  phns?: Phone[];

  /**
   * Bit masks
   *
   */
  bitMsks?: any;

  avatarDocId?: string;

  ttl?: string;
}

export interface Vendor {
  vndId: string;
  cusId: string;
  invite?: {
    c: string;
  };
  sts: number;
  exAto: number;
  vnd?: Vnd;
}

export interface Vnd {
  name: VndName;
}

export interface VndName {
  name: string;
  ent: string;
  email: string;
}
